import { Component, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'dialog-action',
  templateUrl: 'dialog-action.component.html',
  styleUrls: ['./dialog-action.component.scss']
})
export class DialogActionComponent {

  title = '';
  content = '';
  cancelTitle = '';
  cancelNotShow = '';
  okTitle = '';
  okNotShow = '';
  okClass = '';
  modalId = '';
  buttons = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialog: MatDialog
  ) { 
    this.title = data?.title;
    this.content = data?.content;
    this.cancelTitle = data?.cancelTitle || 'Cancelar';
    this.cancelNotShow = data?.cancelNotShow;
    this.okTitle = data?.okTitle || 'Ok';
    this.okNotShow = data?.okNotShow;
    this.okClass = data?.okClass || 'btn-success';
    this.buttons = data?.buttons || [];
    this.modalId = data?.modalId;
  }

  handler(event, item){
    item?.handler(event);
    this.dialog.getDialogById(this.modalId).close();
  }

}